// extracted by mini-css-extract-plugin
module.exports = {"profile__directorsList":"profile-module--profile__directors-list--2Owkk","profile__dataList":"profile-module--profile__data-list--34Vrw"};